"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.send_custom_emailV2 = exports.send_custom_email = void 0;
var _crossFetch = _interopRequireDefault(require("cross-fetch"));
var _datasyncCommonLibrary = require("datasync-common-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//import fetch from "node-fetch";

/**
   * Prototype : send_custom_email
   * Purpose : Deposit acknowledge email 
   * History : 2024-05-16 : Axios replaced with fetch
   */
const send_custom_email_DEFECTIVE = async mailsync_object_parameters => {
  //Prepare send_custom_email POST request
  const POSTform = new FormData();
  POSTform.append("mailsync_url", mailsync_object_parameters.mailsync_url);
  POSTform.append("from", mailsync_object_parameters.from);
  POSTform.append("email", mailsync_object_parameters.email);
  POSTform.set("email", mailsync_object_parameters.email);
  POSTform.append("subject", mailsync_object_parameters.subject);
  POSTform.append("token", mailsync_object_parameters.token);
  POSTform.append("template", mailsync_object_parameters.template);
  console.clear();
  console.log("DsMail.jsx::send_custom_email =>", mailsync_object_parameters);
  /*--------------------------*/

  await (0, _crossFetch.default)(`${mailsync_object_parameters.mailsync_url}/send-custom-email`, {
    method: "POST",
    body: mailsync_object_parameters
  }).then(mailResult => {
    return mailResult.text();
  }).then(mailResult_as_text => {
    let mailResult_as_object = JSON.parse(mailResult_as_text);
    console.log("send_custom_email::mailResult_as_object 3 ->", mailResult_as_object);
    return {
      err: false,
      msg: null
    };
  }).catch(err => {
    console.log('send_custom_email error -> ', err);
    return {
      err: true,
      msg: err
    };
  });
};

/**
   * Prototype : send_custom_email
   * Purpose : Deposit acknowledge email 
   * History : 2024-05-16 : Axios replaced with fetch
   */
const send_custom_email_OK = async mailsync_object_parameters => {
  //Prepare send_custom_email POST request
  const POSTform = new FormData();
  POSTform.append("mailsync_url", mailsync_object_parameters.mailsync_url);
  POSTform.append("from", mailsync_object_parameters.from);
  POSTform.append("email", mailsync_object_parameters.email);
  POSTform.set("email", mailsync_object_parameters.email);
  POSTform.append("subject", mailsync_object_parameters.subject);
  POSTform.append("token", mailsync_object_parameters.token);
  POSTform.append("template", mailsync_object_parameters.template);
  console.clear();
  console.log("DsMail.jsx::send_custom_email =>", mailsync_object_parameters);
  /*
   const response = await fetch('https://httpbin.org/post', {
   method: 'post',
   body: JSON.stringify(body),
   headers: {'Content-Type': 'application/json'}
   });
   const data = await response.json();
    console.log(data);
  --------------------------*/

  const response = await (0, _crossFetch.default)(`${mailsync_object_parameters.mailsync_url}/send-custom-email`, {
    method: 'post',
    body: JSON.stringify(mailsync_object_parameters),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const data = await response.json();
  console.log(data);
};

/**
   * Prototype : send_custom_email
   * Purpose : Deposit acknowledge email 
   * History : 2024-05-16 : Axios replaced with fetch
   */
const send_custom_email = async mailsync_object_parameters => {
  const response = await (0, _crossFetch.default)(`${mailsync_object_parameters.mailsync_url}/send-custom-email`, {
    method: 'post',
    body: JSON.stringify(mailsync_object_parameters),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const data = await response.json();
  return data;
};

/**
   * Prototype : send_custom_emailV2
   * Purpose : Send custom email with callback request
   * History : Created on 2024-06-02
   */
exports.send_custom_email = send_custom_email;
const send_custom_emailV2 = async mailsync_object_parameters => {
  try {
    //Check assertions first
    (0, _datasyncCommonLibrary.Assert)(mailsync_object_parameters.onMailSent);
    (0, _datasyncCommonLibrary.Assert)(mailsync_object_parameters.onMailFailed);
    const send_custom_emailV2_response = await (0, _crossFetch.default)(`${mailsync_object_parameters.mailsync_url}/send-custom-email`, {
      method: 'post',
      body: JSON.stringify(mailsync_object_parameters),
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (mailsync_object_parameters.debugging) console.log("send_custom_emailV2 answers ->", send_custom_emailV2_response);
    if (send_custom_emailV2_response.ok) {
      //Sent succedeed
      mailsync_object_parameters.onMailSent(mailsync_object_parameters);
    } else {
      //Sent fails
      mailsync_object_parameters.onMailFailed(mailsync_object_parameters);
    }
  } catch (err) {
    //Something went wrong
    mailsync_object_parameters.onMailFailed(mailsync_object_parameters);
  }
};
exports.send_custom_emailV2 = send_custom_emailV2;